<div class="books-page">

  <div class="filters-panel"  *ngIf="showFilters">

    <div class="products-filter-item">

      <div class="dropped-filter-list">
        <mat-select #selectGenre placeholder="Категория" (opened)="categoryState = 'expanded'" (closed)="categoryState = 'initial'"
                    (selectionChange)="change()">
          <mat-option>Все</mat-option>
          <mat-option *ngFor="let i of genres" [value]="i.id">
            {{i.genre}}
          </mat-option>
        </mat-select>
      </div>


    </div>

    <div class="products-filter-item">

      <div class="dropped-filter-list">
        <mat-select #selectAge placeholder="Фильтр по возрастам" (opened)="ageState = 'expanded'" (closed)="ageState = 'initial'"
                    (selectionChange)="change()">
          <mat-option>Все</mat-option>
          <mat-option *ngFor="let i of ageCategories" [value]="i.id">
            {{i.ageCategory}}
          </mat-option>
        </mat-select>

      </div>

    </div>


    <div class="products-filter-item">

      <div class="dropped-filter-list">
        <mat-select #selectSort placeholder="Сортировать" (opened)="sortState = 'expanded'" (closed)="sortState = 'initial'"
                    (selectionChange)="change()">
          <mat-option>По умолчанию</mat-option>
          <mat-option *ngFor="let i of sortTypes" [value]="i.value">
            {{i.name}}
          </mat-option>
        </mat-select>

      </div>

    </div>
  </div>

  <div class="products-list-cont">

    <products  [productsCountOnPage]="productsOnPage"
               [productType]="this.productType"
               [genres]="this.filterGenre"
               [pageName]="pageName"
               [availability]="'in_stock,expected'"
              #products></products>
  </div>


</div>
